let zh = {
  componentModule: "元件列表",
  componentMenu: "元件菜单",
  componentCreationReview: "元件创建与审核",
  paramsManagement: "参数管理",
  manufacturerManagement: "制造商",
  encapsulationTypeManagement: "封装类型",
  componentMaterial: "材质配置",
  componentParameters: "元件参数",
  systemSettings: "系统设置",
  permissionManagement: "权限管理",
  accountManagement: "账号管理",
  operationLog: "操作日志",
  databaseManagement: "数据库管理",
  version: "版本号",
  systemGuidelines: "系统指引",
  login: "登录",
  zhmmdl: "账号密码登录",
  xgsjk: "修改数据库",
  enterUsername: "请输入用户名称",
  enterPass: "请输入用户密码",
  remPass: "记住密码",
  forgotPass: "忘记密码",
  xgzhmm: "修改账号密码",
  qd: "确定",
  cancel: "取消",
  sslxqh: "搜索类型切换",
  jqss: "精确搜索",
  mhss: "模糊搜索",
  zzsmc: "制造商名称",
  enterZzs: "请输入制造商名称(EN)",
  zzslh: "制造商料号",
  enterzzslh: "请输入制造商料号",
  zzsfzmc: "制造商封装名称",
  enterzzsfzmc: "请输入制造商封装名称",
  cjz: "创建者",
  entercjz: "请输入创建者名称",
  createTime: "创建时间",
  startTime: "开始时间",
  endTime: "结束时间",
  reset: "重置",
  search: "查询",
  searchSet: "搜索配置",
  plsc: "批量删除",
  dr: "导入",
  dc: "导出",
  zdsz: "字段设置",
  xh: "序号",
  fzlx: "封装类型",
  fzzlx: "封装子类型",
  length: "长",
  width: "宽",
  gong: "共",
  tiao: "条",
  everyPage: "每页",
  go: "前往",
  sszdpz: "搜索字段配置",
  pn: "PN码",
  yjxx: "元件信息",
  yjc: "元件长",
  yjk: "元件宽",
  yjg: "元件高",
  yjmx: "引脚模型",
  yjsl: "引脚数量",
  yjjj: "引脚间距",
  csmc: "参数名称",
  csm: "参数名",
  csz: "参数值",
  cszfw: "参数值范围",
  shz: "审核者",
  shsj: "审核时间",
  drgxyjxx: "导入更新元件信息",
  rz: "日志",
  xzxydrdsjk: "选择需要导入的数据库",
  cslj: "测试连接",
  yshyssffg: "已审核元件是否覆盖",
  yes: "是",
  no: "否",
  dkbglj: "打开报告路径",
  dcyjxx: "导出元件信息",
  xzxydcdsjk: "选择需要导出的数据库",
  zhmc: "账号名称",
  enterZhmc: "请输入账号名称",
  zhqx: "账号权限",
  xjzh: "新增账号",
  bjzh: "编辑账号",
  zt: "状态",
  fpqx: "分配权限",
  cz: "操作",
  bj: "编辑",
  sc: "删除",
  yjbjq: "元件编辑器",
  xjandbjzh: "新建&编辑账号",
  zhmm: "账号密码",
  enterZhmm: "请输入账号密码",
  qrmm: "确认密码",
  enterQrmm: "请再次输入账号密码",
  sfqy: "是否启用",
  exitVal: "退出登录",
  all: "全部",
  jscd: "角色菜单",
  cjjs: "创建角色",
  bjjs: "编辑角色",
  qsrjsm: "请输入角色名",
  qsr: "请输入",
  jsm: "角色名",
  qxsz: "权限设置",
  qrsctc: "确认删除",
  qrscjs: "是否确定要删除，删除后无法恢复！",
  bm: "所属部门",
  qsrbm: "请输入所属部门",
  qxzfpqx: "请选择分配权限",
  qxzsfqy: "请选择是否启用",
  mmbyz: "两次密码不一致",
  isSubmiting: "提交中",
  fzlxmc: "封装类型名称",
  enterfzlxmc: "请输入封装类型名称",
  fzzlxbz: "封装子类型备注",
  enterfzzlxbz: "请输入封装子类型备注",
  fzlxbz: "封装类型备注",
  enterfzlxbz: "请输入封装类型备注",
  fzzlxmc: "封装子类型名称",
  enterfzzlxmc: "请输入封装子类型名称",
  pleaseEnter: "请输入",
  add: "新增",
  bz: "备注",
  xzfzlx: "新增封装类型",
  bjfzlx: "编辑封装类型",
  fzlxxx: "封装类型信息",
  qsrzzsmc: "请输入制造商名称",
  hbzzs: "合并制造商",
  bdyjsl: "绑定元件数量",
  gfwz: "官方网站",
  yj: "邮件",
  shzt: "审核状态",
  sh: "审核",
  dsh: "待审核",
  ysh: "已审核",
  zzsbmxs: "制造商别名显示",
  zzsbm: "制造商别名",
  zzsxx: "制造商信息",
  zzswz: "制造商网站",
  zzsyj: "制造商邮件",
  sftgzzs: "是否审核通过该制造商?",
  drzzsxx: "导入制造商信息",
  mbxz: "模板下载",
  xzzzsdrmb: "下载制造商导入模板",
  drxx: "导入信息",
  drts: "点击选择CSV文件，仅支持.csv格式文件，不超过50MB",
  zzshb: "制造商合并",
  hb: "合并",
  jiang: "将",
  hbjzzs: "合并进制造商",
  qsrzzsmcjxss: "请输入制造商名称进行搜索",
  hbfs: "合并方式",
  tszyzzs: "同时转移制造商",
  jjxqjzy: "仅进行器件转移",
  jxhb: "进行合并",
  hbjxzts: "合并进行中，请勿关闭系统",
  fzzlxxx: "封装子类型信息",
  dlrz: "登录日志",
  czrz: "操作日志",
  hyzh: "会员账号",
  qsrzhcx: "请输入账号查询",
  dlsj: "登录时间",
  dlzh: "登录账号",
  qx: "权限",
  rznr: "日志内容",
  czsj: "操作时间",
  czlx: "操作类型",
  zh: "账号",
  plscqr: "请确认是否删除所选封装类型，删除后数据不可恢复",
  plscqr2: "请确认是否删除所选制造商，删除后数据不可恢复",
  plscqr3: "请确认是否删除所选数据库，删除后数据不可恢复",
  xgmm: "修改密码",
  srjmm: "输入旧密码",
  srxmm: "输入新密码",
  qrxmm: "确认新密码",
  ts: "提示",
  xgmmcg: "修改密码成功！",
  zbmhhss: "主别名混合搜索",
  qxz: "请选择",
  xzzzs: "新增制造商",
  bjzzs: "编辑制造商",
  qsrzzswz: "请输入制造商网站",
  qsrzzsyj: "请输入制造商邮件",
  pic: "2D/3D切换",
  kssj: "开始时间",
  jssj: "结束时间",
  jcxx: "基础信息",
  bjxx: "编辑信息",
  dqxzzd: "当前选择字段",
  qsrzzsbmen: "请输入制造商别名(EN)",
  qsrzzsbmcn: "请输入制造商别名(CN)",
  cx: "撤销",
  pz: "批准",
  gao: "高",
  bjz: "编辑者",
  bjsj: "编辑时间",
  syzd: "所有字段",
  zdpzts: "使用者自行添加的元件参数，会默认展示在此处",
  enterPn: "请输入PN码",
  dryj: "导入元件",
  yxyjdc: "已选元件导出",
  cjsjdc: "创建时间导出",
  cjry: "创建人员",
  xjsjk: "新建数据库",
  xjyqj: "新建元器件",
  dqsjklb: "当前数据库列表",

  dlfs: "登录方式",
  qds: "驱动",
  server: "服务器",
  port: "端口",
  username: "用户名",
  psw: "密码",
  database: "数据库",
  parameter: "参数",
  confirm: "确认",
  edit: "修改",
  testlink: "测试链接",

  sjkmc: "数据库名称",
  sjkdz: "数据库地址",
  sjkdk: "数据库端口",
  sjkzt: "状态",
  xz: "选择",
  yzsb: "验证失败",
  yztg: "验证通过",
  dyz: "待验证",
  qxzdlsjk: "请选择需要登陆的数据库",
  xzsjkbtn: "选择数据库",
  dqxz: "当前选择",
  testErrMsg: "请先新建数据库后再测试链接",
  qxzsjk: "请选择数据库",
  shtg: "审核通过",
  zm: "主名",
  bm: "别名",
  wjqddc: '文件清单导出',
  qxfpqx: '请先分配权限',
  loading: '加载中...',
  view: "查看",
  sjkbf: '当前数据库备份',
  gd: '更多',
  fz: '复制',
  cxMPN: '重新关联MPN',
  szclys: '设置材料和颜色',
  switchtext: '开启元件参数设置，则创建元件时支持设置元件参数',
  xjyjcs: '新增元件参数',
  bjyjcs: '编辑元件参数',
  cslx: '元件参数类型',
  qxzcslx: '请选择元件参数类型',
  yjcsm: '元件参数名',
  enterYjcsm: '请输入元件参数名',
  yjcsdw: '元件参数单位',
  enterYjcsdw: '请输入元件参数单位',
  lx: '类型',
  dw: '单位',
  czbm: '材质编码',
  czmc: '材质名称',
  enterCzbm: '请输入材质编码',
  enterCzmc: '请输入材质名称',
  elementConfiguration: '元素配置',
  yuansu: '元素',
  tslx: '特殊类型',
  yanse: '颜色',
  yjcz: '元件操作',
  pleaseEnter2: "请输入",
  qxz2: '请选择',
  startTime2: "开始时间",
  endTime2: "结束时间",
  xzys: '新增元素',
  ysmc: '元素名称',
  ysbh: '元素编号',
  enterYsbh: '请选择元素编号',
  enterYsmc: '请输入元素名称',
  bjys: '编辑元素',
  tslxbh: '特殊类型编号',
  enterTslxbh: '请选择特殊类型编号',
  tslxmc: '特殊类型名称',
  enterTslxmc: '请输入特殊类型名称',
  yanse: '颜色',
  yansebh: '颜色编号',
  yansemc: '颜色名称',
  enterYansebh: '请选择颜色编号',
  enterYansemc: '请输入颜色名称',
  xztslx: '新增特殊类型',
  bjtslx: '编辑特殊类型',
  xzyanse: '新增颜色',
  bjyanse: '编辑颜色',
  zdyyjcskg: '自定义元件参数开关',
  ycjyjcs: '已创建元件参数',
  ysczzh: '元素材质组合',
  czbm: '材质编码',
  czmc: '材质名称',
  xzyjcz: '新增元件材质',
  bjyjcz: '编辑元件材质',
  czlx: '材质类型',
  mc: '名称',
  hj: '合金',
  tc: '涂层',
  yssl: '元素数量',
  xzyssl: '请选择元素数量',
  dyzys: '第一种元素',
  derzys: '第二种元素',
  qxzys: '请选择元素',
  xzxsys: '选择显示颜色',
  baocun: '保存',
  qxzyanse: '请选择颜色',
  qxzlx: '请选择类型',
  assignMaterials: '分配材质',
  wsyczlb: '未使用材质列表',
  ysyczlb: '已使用材质列表',
  yzbt: '用作本体',
  yzyj: '用作引脚',
  tszy: '同时作用',
  yc: '移除',
  czlb: '材质列表',
  btczlb: '本体材质列表',
  yjczlb: '引脚材质列表',
  bh: '编号',
  gx: '更新',
  ysczzhycz: '此元素材质组合编号已存在',
  xinjian: '新建',
  zhantie: '粘贴',
  szczhys: '设置材质和颜色',
  bjmpnhmfg: '编辑MPN和MFG',
  sjklx: '数据库类型',
  jzzsmc: '旧制造商名称',
  xzzsmc: '新制造商名称',
  jzzslh: '旧制造商料号',
  xzzslh: '新制造商料号',
  enterXzzsmc: '请选择新制造商名称',
  enterXzzslh: '请输入新制造商料号',
  xuanzhuan: '旋转',
  sjzs: '数据展示',
  liebiao: '列表',
  cssj: '参数数据',
  benti: '本体',
  xingzhuang: '形状',
  ysfx: '延伸方向',
  yinjiao: '引脚',
  yjmc: '引脚名称',
  jxyj: '极性元件',
  weizhi: '位置',
  zjz: '中间值',
  zpc: '正偏差',
  fpc: '负偏差',
  zdz: '最大值',
  zxz: '最小值',
  jztx: '加载图形',
  clgj: '测量工具',
  jzdt: '加载底图',
  jzpdf: '加载PDF',
  gbpdf: '关闭PDF',
  yjshlc: '元件审核流程',
  bzms: '标注模式',
  zzms: '公差模式',
  psyj: '评审意见',
  tuichu: '退出',
  syg: '上一个',
  xyg: '下一个',
  pldrsn: '批量导入PN',
  xzsndrmb: '下载PN导入模板',
  drsb: '导入异常',
  drsbqd: '导入失败清单',
  xzcwbg: '下载错误报告',
  xzbg: '下载报告',
  gaodu: '高度',
  step1: '基本信息确认',
  tip1: '已上传底图及PDF手册',
  tip2: '制造商名称、制造商料号、制造商封装名称与手册一致',
  tip3: '封装类型、封装子类型选择正确',
  tip4: '本体材质、引脚材质、器件参数与手册一致',
  step2: '极性信息确认',
  tip5: '极性元件选择正确',
  tip6: '极性位置放置正确',
  step3: '本体信息确认',
  tip7: '本体形状、抬升高度正确',
  tip8: '本体尺寸正确',
  step4: '引脚信息确认',
  tip9: '引脚模型及形状正确',
  tip10: '引脚位置、方向正确',
  step5: '确认其余参数是否正确',
  tip11: '引脚名称正确',
  kai: '开',
  guan: '关',
  enterBz: '请输入备注',
  plppyj: '批量匹配元件',
  xzdrmb: '下载导入模板',
  ppyqjsfzkz: '匹配元器件是否在库中存在',
  ppcg: '匹配成功',
  ppsb: '匹配失败',
  ppl:'匹配率',
  ppsbqd: '匹配失败清单',
  ppyc: '匹配异常',
  drcg: '导入成功',
  drsbai: '导入失败',
  kshbzzs: '开始进行制造商合井',
  dhbyjsl: '待合并元件数量',
  hbyc: '合并失败',
  hbcg: '合并成功',
  cwrz: '错误日志',
  qxzzzs: '请选择制造商名称',
  zzslhlb: '制造商料号列表',
  lhtpf: '是否共享封装图形',
  gllh: '关联料号',
  czcg: '操作成功',
  qxzydcdx: '请选择要导出的元件',
  zdzxzms: '极值模式',
  hbcgyjsl: '合并成功元件数量',
  dcz: '导出中...',
  ksjxdc: '开始进行导出...',
  dcyjsl: '导出元件数量',
  dcwc: '导出完成',
  dcsb: '导出失败',
  ksjxdr: '开始进行导入...',
  drwc: '导入完成',
  page: '页',
  clgl: '材料管理',
  bccg: '保存成功',
  shtgl: '审核通过',
  shwtgl: '审核未通过',
  dcmy: '没有符合的导出内容',
  juxing: '矩形',
  yuanxing: '圆形',
  duobianxing: '多边形',
  zhijing: '直径',
  plexe: '批量刷新',
  plsxQxz: '请选择元件',
  plsxfzlxyjmx: '批量刷新封装类型和引脚模型',
  dccg: '导出成功',
  hengxiang: '横向',
  zongxiang: '纵向',
  sflx: '是否类型',
  ryzfclx: '任意字符串类型',
  rqlx: '日期类型',
  zslx: '整数类型',
  zdylx: '自定义类型',
  quanxuan: '全选',
  enterZzslhlb: '请输入制造商料号列表',
  jbxx: '基本信息',
  zhi: '值',
  tbyjcs: '同步元件参数',
  refresh: '刷新',
  bzsc: '帮助手册',
  zzs: ' 制造商',
  yjcs: '元件参数',
  btcl: '本体材料',
  yjcl: '引脚材料',
  yqwq: '有铅/无铅',
  ESDdj: 'ESD等级',
  zl: '重量',
  smdj: '湿敏等级',
  bzjd: '包装角度',
  bzpitch: '包装pitch',
  bzfs: '包装方式',
  gl: '功率',
  RoHShbyq: 'RoHS环保要求',
  wd: '温度',
  xzcs: '新增参数',
  dcyjcs: '导出元件参数',
  pldrcs: '批量导入参数',
  wx: '外形',
  yinj: '引脚',
  cs: '参数',
  cjxz: '创建/审核',
  fg: '覆盖',
  zj: '追加',
  overwriteDialogMessage: '参数存在重复，请确认是否覆盖？',
  bjyqj: '编辑元器件',
  drjg: '导入结果',
  enterYjzdycs: '请输入元件自定义参数',
  yjzdycs: '元件自定义参数',
  qxzsj: '请选择时间',
  tsgd: '抬升高度',
  cd: '长度',
  kd: '宽度',
  jx:'极性',
  qxcl: '清除测量',
  spwtgbsp: '审核未通过元器件不允许撤销或批准',
  fzzzs: '复制制造商',
  dycg: '调用成功',
  fzyj: '复制元器件'
};

export default zh;
